import React from 'react';
import { CapacityResponse } from '@features/desks/services/OfficeCapacityService';
import styled from "styled-components";
import { BodyVerySmall } from "../../../atoms/fonts/Body";
import { Column, Row } from "../../../atoms/StructuralLayout";
import { SimpleSpinner } from "../../../atoms/SimpleSpinner";
import { useTranslation } from "react-i18next";
import { CarParkingCapacityLabel } from "./CarParkingCapacityLabel";
import { WithOfficeCapacity } from "../hooks/WithCapacity";
import { IconTypes } from "../../../atoms/icon/Icon";

export function WhereaboutsCapacityLabel(props: Props) {
  const {capacity, isCarParkingEnabledForCompany} = props;
  const {t} = useTranslation();

  const availableSpaces = WithOfficeCapacity(capacity);

  return (
    <Column>
      <Row style={{alignItems: 'center', minHeight: 24}}>
        {!!capacity ? <>
          {availableSpaces === 0.5 ? <>
            <DeskAvailabilityLabel><span>&#189;</span></DeskAvailabilityLabel>
          </> : <>
            <DeskAvailabilityLabel>{availableSpaces}</DeskAvailabilityLabel>
          </>}
        </> : <SimpleSpinner size={20} /> }
        <DeskAvailabilityLabel style={{marginLeft: 4}}>{t('whereabouts.desks-available')}</DeskAvailabilityLabel>
      </Row>

      <CarParkingCapacityLabel isCarParkingEnabledForCompany={isCarParkingEnabledForCompany} capacity={capacity} />

    </Column>
  )
}

interface Props {
  capacity?: CapacityResponse;
  isCarParkingEnabledForCompany: boolean;
}


const DeskAvailabilityLabel = styled(BodyVerySmall)`
  margin-top: -4px;
`
